import { createStyles } from 'antd-style';

export const useStyles = createStyles(
  (
    { token, css, cx, prefixCls, stylish },
    { variant, expand }: { variant: 'filled' | 'outlined' | 'borderless'; expand?: boolean }
  ) => {
    const prefix = `${prefixCls}-highlighter`;
    const buttonHoverCls = `${prefix}-hover-btn`;
    const langHoverCls = `${prefix}-hover-lang`;

    const variantStylish = css`
      background-color: ${variant === 'filled' ? token.colorFillTertiary : 'transparent'};
      border: 1px solid ${variant === 'filled' ? 'transparent' : token.colorBorder};

      &:hover {
        background-color: ${variant === 'filled'
          ? token.colorFillTertiary
          : token.colorFillQuaternary};
      }
    `;

    return {
      button: cx(
        buttonHoverCls,
        css`
          position: absolute;
          z-index: 2;
          inset-block-start: ${variant === 'borderless' ? 0 : '12px'};
          inset-inline-end: ${variant === 'borderless' ? 0 : '12px'};

          opacity: 0;
        `
      ),

      container: cx(
        prefix,
        variant !== 'borderless' && variantStylish,
        css`
          position: relative;

          overflow: hidden;

          height: ${expand ? '100%' : 'auto !important'};

          border-radius: ${token.borderRadius}px;

          transition: background-color 100ms ${token.motionEaseOut};

          &:hover {
            .${buttonHoverCls} {
              opacity: 1;
            }

            .${langHoverCls} {
              opacity: 1;
            }
          }

          .prism-code {
            background: none !important;
          }

          pre {
            height: 100%;
            margin: 0 !important;
            padding: ${variant === 'borderless' ? 0 : `16px`} !important;
          }
        `
      ),
      header: css`
        padding-block: 4px;
        padding-inline: 8px;
        background: ${token.colorFillQuaternary};
      `,
      lang: cx(
        langHoverCls,
        stylish.blur,
        css`
          position: absolute;
          z-index: 2;
          inset-block-end: 12px;
          inset-inline-end: 4px;

          font-family: ${token.fontFamilyCode};
          color: ${token.colorTextSecondary};

          opacity: 0;

          transition: opacity 0.1s;
        `
      ),
      wrap: css`
        pre {
          white-space: break-spaces;
        }
      `,
      scroller: css`
        overflow: auto;
        width: 100%;
        height: 100%;
      `,
      select: css`
        user-select: none;
        font-size: 14px;
        color: ${token.colorTextDescription};
        .${prefixCls}-select-selection-item {
          min-width: 100px;
          padding-inline-end: 0 !important;
          color: ${token.colorTextDescription};
          text-align: center;
        }
      `,
    };
  }
);
